import { ThumbsUpV2 } from 'src/shared/design-system/Icon';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  position: relative;
  padding: ${Spacing.SINGLE_HALF} 0 0;
  & input {
    position: relative;
    top: -24px;
  }

  ${Mixins.Media.minWidthMedium(`
    max-width: 400px;
  `)}
`;

export const BarContainer = styled.div`
  height: ${Spacing.QUARTER};
  width: 100%;
  position: relative;
`;

export const ScrubberContainer = styled.div`
  height: ${Spacing.QUARTER};
  width: calc(100% - 24px);
  position: relative;
  transform: translate(12px, -8px);
`;

export const BarBackground = styled.div`
  background: ${Colors.RADISH};
  border-radius: ${Spacing.QUARTER};
  height: ${Spacing.QUARTER};
  width: 100%;
  position: relative;
`;

export const Bar = styled.div`
  position: absolute;
  background: ${Colors.GRAY_LITE_10};
  border-radius: ${Spacing.HALF};
  height: ${Spacing.QUARTER};
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
`;

export const Scrubber = styled.div`
  background: ${Colors.WHITE};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  position: absolute;
  top: -6px;
  transform: translateX(-50%);
  ${Mixins.Shape.circle(Spacing.SINGLE_HALF)};
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  justify-content: space-between;
  margin-top: ${Spacing.TRIPLE_HALF};
  top: 0;
  left: 0;
  right: 0;
`;

export const Label = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  font-weight: ${Font.Weight.SEMI_BOLD};
  gap: ${Spacing.HALF};

  ${({ isSelected }) =>
    isSelected
      ? css`
          color: ${Colors.GRAY_DARK_30};
        `
      : css`
          color: ${Colors.GRAY_DARK_10};
        `}
`;

export const LabelIcon = ThumbsUpV2;

export const Input = styled.input.attrs(() => ({ type: 'range', min: '0', max: '100' }))`
  -webkit-appearance: none;
  height: ${Spacing.QUINTUPLE};
  border-radius: ${Border.Radius.M};
  background: none;
  opacity: 0.1;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  margin-bottom: -${Spacing.TRIPLE};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: none;
    opacity: 0;
    width: ${Spacing.DOUBLE_HALF};
    height: ${Spacing.DOUBLE_HALF};
    cursor: pointer;
  }

  &::-moz-range-thumb {
    appearance: none;
    background: none;
    opacity: 0;
    width: ${Spacing.DOUBLE_HALF};
    height: ${Spacing.DOUBLE_HALF};
    cursor: pointer;
  }
`;
